import * as ngCore from '@angular/core'
import * as ents from '@attain-apps/entities'
import * as ec from '@attain-apps/fe/web/main/lib/entity-collection'
import { TypeAsserter } from '@attain-apps/type-guards'
import * as rxjs from 'rxjs'

import * as common from '../../dms/common'

import * as gql from './gql'
import * as models from './models'

@ngCore.Injectable({ providedIn: 'root' })
export class Api {
  /** Loads reference records for a given entity, optionally filtered by record IDs. */
  public loadRecords(
    input: models.Context,
  ): rxjs.Observable<readonly models.Record[]> {
    const { entityId, recordIds, ...context } = input
    return gql.queries.records.execute({
      ...context,
      // Stringify the query because GraphQL expects an AWSJSON type. Since we
      // don't have a TypeScript representation for AWSJSON, we use 'any' type.
      query: JSON.stringify({
        ...(recordIds?.length
          ? { filter: { in: [{ '@.': '!id' }, { '[]': recordIds }] } }
          : {}),
        noUnpacking: true,
        selection: {
          '{}': {
            ancestors: { '@': 'ancestors' },
            id: { '@.': '!id' },
            name: { '@.': '!name' },
            // NOTE: all properties of models.Record type must be selected here,
            // with values being dms Expression functions
          } satisfies Record<
            keyof models.Record,
            ents.core.dms.data.expression.Expression
          >,
        },
        sort: {
          by: { '@.': '!name' },
        },
        subqueries: {
          ancestors: {
            selection: {
              '{}': {
                key: { '@_': 'id' },
                value: { '@.': '!name' },
              },
            },
            target: 'ancestors',
          },
        },
        target: entityId,
      }),
    })
  }

  /** @inheritdoc */
  public create(context: models.Context, input: models.CreateEntity) {
    if (!context?.entityId) {
      // If we do not have a current entity, we can't create records
      return rxjs.throwError(
        // TODO: better error handling
        () => new Error('Unable to determine current entity'),
      )
    }
    TypeAsserter.assertIsNotNullish(context)
    const { tenantId, zoneId, entityId } = context
    return common.gql.mutations.putZoneData.executor({
      insertion: {
        inputs: {
          records: [
            JSON.stringify({
              ...input,
              [ents.core.dms.data.Record.Id.KEY]: undefined,
            }),
          ],
        },
        modelId: entityId,
      },
      tenantId,
      zoneId,
    })
  }
}
